'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Immutable = require('Immutable');

var _enums = require('MeetingsBase/constants/enums');

var _CustomHostedDomain = require('MeetingsBase/models/CustomHostedDomain');

var _CustomHostedDomain2 = _interopRequireDefault(_CustomHostedDomain);

var _Branding = require('MeetingsBase/models/Branding');

var _Branding2 = _interopRequireDefault(_Branding);

var _UserProfile = require('MeetingsBase/models/UserProfile');

var _UserProfile2 = _interopRequireDefault(_UserProfile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaults = {
  calendarAccountId: null,
  portalId: null,
  branding: _Branding2.default.from(),
  id: null,
  userId: null,
  namespace: null,
  calendarIntegrationChoice: _enums.CAL_INTEGRATIONS.GOOGLE,
  calendarEmail: null,
  calendarIdToWriteTo: null,
  calendarIdsToCheck: (0, _Immutable.Map)(),
  calendarDisplayNames: (0, _Immutable.Map)(),
  unavailableCalendarIds: (0, _Immutable.List)(),
  userProfile: _UserProfile2.default.from({}),
  defaultLinkId: null,
  isSalesStarter: false,
  customHostedDomain: null,
  isOnboarded: true
};

var MeetingsUser = function (_Record) {
  _inherits(MeetingsUser, _Record);

  function MeetingsUser() {
    _classCallCheck(this, MeetingsUser);

    return _possibleConstructorReturn(this, (MeetingsUser.__proto__ || Object.getPrototypeOf(MeetingsUser)).apply(this, arguments));
  }

  _createClass(MeetingsUser, [{
    key: 'toJSON',
    value: function toJSON() {
      return {
        meetingsUserBlob: {
          calendarSettings: {
            provider: this.get('calendarIntegrationChoice'),
            email: this.get('calendarEmail'),
            calendarAccountId: this.get('calendarAccountId'),
            calendarIdToWriteTo: this.get('calendarIdToWriteTo'),
            calendarIdsToCheck: this.get('calendarIdsToCheck').toJS(),
            calendarDisplayNames: this.get('calendarDisplayNames').toJS()
          }
        },
        namespace: this.get('namespace')
      };
    }
  }, {
    key: 'setUnavailableCalendarIds',
    value: function setUnavailableCalendarIds(calendarVerification) {
      var calendarVerificationForOwner = calendarVerification.get(this.get('calendarEmail'));

      var unavailableCalendarIds = calendarVerificationForOwner ? calendarVerificationForOwner.get('failedCalendarErrors').keySeq().toList() : (0, _Immutable.List)();
      return this.set('unavailableCalendarIds', unavailableCalendarIds);
    }
  }], [{
    key: 'from',
    value: function from(json) {
      var calendarIdsToCheck = {};
      if (json.meetingsUserBlob.calendarSettings.calendarIdsToCheck) {
        var _json$meetingsUserBlo = json.meetingsUserBlob.calendarSettings.calendarIdsToCheck,
            primary = _json$meetingsUserBlo.primary,
            rest = _objectWithoutProperties(_json$meetingsUserBlo, ['primary']);

        calendarIdsToCheck = rest;
      }

      return new MeetingsUser({
        portalId: json.portalId,
        branding: _Branding2.default.from(json.meetingsUserBlob.brandSettings),
        id: json.id,
        userId: json.userId,
        namespace: json.namespace,
        userProfile: _UserProfile2.default.from(json.userProfile),
        calendarAccountId: json.meetingsUserBlob.calendarSettings.calendarAccountId,
        calendarIntegrationChoice: json.meetingsUserBlob.calendarSettings.provider,
        calendarEmail: json.meetingsUserBlob.calendarSettings.email,
        calendarIdToWriteTo: json.meetingsUserBlob.calendarSettings.calendarIdToWriteTo || null,
        calendarIdsToCheck: (0, _Immutable.Map)(calendarIdsToCheck),
        calendarDisplayNames: (0, _Immutable.Map)(json.meetingsUserBlob.calendarSettings.calendarDisplayNames),
        isSalesStarter: json.hasSalesStarterFeatures || json.salesPro || false,
        customHostedDomain: _CustomHostedDomain2.default.from(json.customHostedDomain),
        isOnboarded: json.isOnboarded
      });
    }
  }]);

  return MeetingsUser;
}((0, _Immutable.Record)(defaults));

exports.default = MeetingsUser;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsBase/target/src/MeetingsBase/static-1.2449/js/models/MeetingsUser.js
// module id = 193
// module chunks = 0